import { Building2, Check, Layers3, Rocket, ShieldCheck } from 'lucide-react'

const editionCatalog = [
  {
    code: 'BASIC', name: '基础版', alias: 'Basic 商用版', icon: Rocket,
    stage: '起步商用',
    audience: '入门商用客户',
    summary: '最基础的功能集合，所有版本均包含此部分能力。',
    moduleHeading: '基础权益',
    moduleLabel: '基础能力',
    modules: ['基础问答功能', '指标管理', '文件上传问答', '简单权限管理', '系统配置', '移动端 App'],
  },
  {
    code: 'STANDARD', name: '标准版', alias: 'Standard 商用版', icon: ShieldCheck,
    stage: '规模生产', recommended: true,
    audience: '主力商用客户',
    summary: '在基础版本之上增加的增量能力。',
    moduleHeading: '本版本新增权益',
    moduleLabel: '增量能力',
    modules: ['NL2SQL 自由问数', '智能归因', '指标管理增强（血缘查看、智能指标推荐）', '知识、技能和记忆', '企业级权限管理（行级管控、列级脱敏）', '全类型办公文档上传问答', '办公环境覆盖及跨系统对接'],
  },
  {
    code: 'ENTERPRISE', name: '旗舰版', alias: 'Enterprise 旗舰版', icon: Building2,
    stage: '集团与生态',
    audience: '集团、渠道合作伙伴与 OEM 厂商',
    summary: '最高级版本，包含所有基础、标准及专属增量能力。',
    moduleHeading: '本版本新增权益',
    moduleLabel: '专属增量能力',
    modules: ['深度分析', '指标异常检测', '洞察分析报告', '自动任务', '数字人播报', '行业预制分析场景模板'],
  },
] as const

export function ModulesPage() {
  return <div>
    <div className="page-lead"><div><h2>产品权益目录</h2><p>以基础、标准、旗舰三个正式版本呈现授权权益，具体模块组合由商业授权确定。</p></div><div className="catalog-count"><Layers3 size={17} />3 个正式版本</div></div>
    <section className="edition-catalog" aria-labelledby="edition-catalog-title">
      <div className="edition-catalog-heading">
        <div><small>PRODUCT EDITIONS</small><h3 id="edition-catalog-title">选择适合业务阶段的版本</h3></div>
        <p>先判断部署规模和能力边界，再确认交付与服务方式；最终权益以复核通过的商业授权为准。</p>
      </div>
      <div className="edition-selection-guide" aria-label="版本选型步骤">
        <div><span>01</span><b>部署规模</b><small>单节点、集群或多地域</small></div>
        <div><span>02</span><b>能力边界</b><small>核心功能、完整平台或定制扩展</small></div>
        <div><span>03</span><b>交付方式</b><small>标准支持、系统集成或专属交付</small></div>
      </div>
      <div className="edition-catalog-grid" role="list">{editionCatalog.map((edition, index) => {
        const Icon = edition.icon
        return <article className={`edition-catalog-card edition-catalog-card--${index + 1} ${'recommended' in edition && edition.recommended ? 'edition-catalog-card--recommended' : ''}`} key={edition.code} role="listitem">
          <div className="edition-card-top">
            <div className="edition-card-identity"><span className="edition-catalog-icon"><Icon size={20} /></span><div><small>{edition.code}</small><b>{edition.stage}</b></div></div>
            {'recommended' in edition && edition.recommended && <em>主力推荐</em>}
          </div>
          <div className="edition-card-copy">
            <h4>{edition.name}<span>{edition.alias}</span></h4>
            <div className="edition-definition"><small>版本定位</small><p>{edition.summary}</p></div>
            <div className="edition-audience"><small>适用客户</small><b>{edition.audience}</b></div>
          </div>
          <div className="edition-modules">
            <div className="edition-modules-heading"><b>{edition.moduleHeading}</b><small>{edition.modules.length} 项{edition.moduleLabel}</small></div>
            <ul>{edition.modules.map(module => <li key={module}><Check size={13} /><span>{module}</span></li>)}</ul>
          </div>
        </article>
      })}</div>
      <p className="edition-catalog-footnote">版本用于快速选型，不直接替代商业授权。产品组合和特殊条款仍以正式授权快照为准。</p>
    </section>
  </div>
}
